import { render, staticRenderFns } from "./ClientesFtthNaCaixa.vue?vue&type=template&id=7a224d20&scoped=true&"
import script from "./ClientesFtthNaCaixa.vue?vue&type=script&lang=js&"
export * from "./ClientesFtthNaCaixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a224d20",
  null
  
)

export default component.exports